
export default function ContactCTASection() {
  const scrollToDiagnostic = () => {
    const element = document.getElementById('diagnostico');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="container px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center p-6 lg:p-8 bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl">
            <h3 className="text-xl lg:text-2xl font-bold text-white mb-3 lg:mb-4">
              Ainda tem dúvidas?
            </h3>
            <p className="text-white opacity-90 mb-4 lg:mb-6">
              Fale diretamente com nossos especialistas
            </p>
            <div className="flex flex-col sm:flex-row gap-3 lg:gap-4 justify-center">
              <button 
                onClick={scrollToDiagnostic}
                className="border-2 border-white text-white px-6 lg:px-8 py-3 lg:py-4 rounded-lg font-semibold hover:bg-white hover:text-orange-600 transition-colors whitespace-nowrap cursor-pointer text-sm lg:text-base"
              >
                <i className="ri-calendar-line mr-2"></i>
                Agendar Reunião
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
